import React from 'react'
import { connect } from 'react-redux'
import PageWebsitePage from '../../components/PageWebsite/PageWebsitePage';
import config from '../../config.json'
import toJS from '../general/toJS.js'
import { AUTH } from '../../constants/state.js';

const mapStateToProps = state => ({
    routeData: state.getIn(['wpServerData', 'data', 'data', 'routes']),
    caps: state.getIn([AUTH, 'caps'])
})

const PageWebsite = ({saveState, status, routeData, caps}) => {
    let usedRoutes = []

    if(routeData) {
        config.menus.website.map(route  => {
            if(route === 'weischer' || route === 'program' || route  === 'movies' || route === 'advertisement' || route === 'elbenwald') {
                if(routeData[route] === 'true' || routeData[route] === true) {
                    usedRoutes.push(route)
                }
            } else if(route === 'subpages') {
                if(
                    (routeData['website'] === 'true' || routeData['website'] === true) &&
                    (caps.wpPagesGet || caps.wpServicePagesGet || caps.wpDataUpdate)
                ) {
                    usedRoutes.push(route)
                }
            }
        })
    }

    return (
        <PageWebsitePage
            pageName={config.routes.website.name}
            saveState={saveState}
            usedRoutes={usedRoutes}
            status={status}
        />
    )
}


export default connect(mapStateToProps)(toJS(PageWebsite))